var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _rect, _rect2, _path28, _path29, _path30, _path31;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTeam(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "flat-export",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m240 392 16-144 8 152 32-8v-184h-88v192z",
    fill: "#718799"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m208 400v24h56v-16l-24-16z",
    fill: "#e0edff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m264 424h56v-16l-24-16-32 8z",
    fill: "#d1e4ff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m296 160h32v56h-32z",
    fill: "#ffbfa1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m208 88h88v128h-88z",
    fill: "#ffa100"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m208 144v-56h-8a24 24 0 0 0 -24 24v32z",
    fill: "#ffa100"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m176 144h32l56 64h-40l-36.4859-30.40492a32 32 0 0 1 -11.5141-24.58308z",
    fill: "#ffbfa1"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m296 160h32v-48a24 24 0 0 0 -24-24h-8z",
    fill: "#ffa100"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m400 448-16-144-8 152-32-8v-184h88v192z",
    fill: "#718799"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m488 238.88v57.12a15.99555 15.99555 0 0 1 -16 16h-16v-64l-11.59009-19.31-12.40991-20.69v56h-88v-56l-13.33008 10.67-20.09985 16.07a23.94861 23.94861 0 0 1 -14.99 5.26h-39.58007a15.99555 15.99555 0 0 1 -16-16v-16h48l17.46-14.54 21.64-18.04a31.96215 31.96215 0 0 1 20.49009-7.42h82.66991a31.99256 31.99256 0 0 1 27.14 15.04l15.27991 24.45 11.67009 18.67a23.9834 23.9834 0 0 1 3.65 12.72z",
    fill: "#ffceb6"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m305.46 193.46 25.21 25.21 13.33-10.67v56h88v-56l12.40991 20.69 28.27-21.2-15.27991-24.45a31.99256 31.99256 0 0 0 -27.14-15.04h-82.66991a31.96215 31.96215 0 0 0 -20.49009 7.42z",
    fill: "#ffc431"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m376 152v28a12 12 0 1 0 24 0v-28z",
    fill: "#ffceb6"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "m432 456v24h-56v-16l24-16z",
    fill: "#e0edff"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "m376 480h-56v-16l24-16 32 8z",
    fill: "#d1e4ff"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "m376 152v24a15.99555 15.99555 0 0 0 16-16v-8z",
    fill: "#ffbfa1"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "m384 168a16 16 0 0 0 16-16v-8l-8-8h-24v16a16 16 0 0 0 16 16z",
    fill: "#ffceb6"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "m368 136-4.68629-4.68629a11.31372 11.31372 0 0 1 -3.31371-8 11.31369 11.31369 0 0 1 11.3137-11.31371h12.6863a16 16 0 0 1 16 16v16l-8-8z",
    fill: "#c47220"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "m240 208v16a15.99555 15.99555 0 0 0 16 16h26.95a27.73448 27.73448 0 0 0 5.05-16v-16z",
    fill: "#ffbfa1"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "m112 448 16-144 8 152 32-8v-184h-88v192z",
    fill: "#718799"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "m272 208v16a15.99555 15.99555 0 0 1 -16 16h-39.58008a23.94861 23.94861 0 0 1 -14.99-5.26l-20.09985-16.07-13.33007-10.67v56h-88v-56l-12.40991 20.69-11.59009 19.31v64h-16a15.99555 15.99555 0 0 1 -16-16v-57.12a23.9834 23.9834 0 0 1 3.65-12.72l11.67005-18.67 15.27995-24.45a31.99256 31.99256 0 0 1 27.14-15.04h82.66992a31.96215 31.96215 0 0 1 20.49008 7.42l21.64 18.04 17.46 14.54z",
    fill: "#ffceb6"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "m206.54 193.46-25.21 25.21-13.33-10.67v56h-88v-56l-12.40991 20.69-28.27-21.2 15.27991-24.45a31.99256 31.99256 0 0 1 27.14-15.04h82.66992a31.96215 31.96215 0 0 1 20.49008 7.42z",
    fill: "#ffc431"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "m136 152v28a12 12 0 1 1 -24 0v-28z",
    fill: "#ffceb6"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "m80 456v24h56v-16l-24-16z",
    fill: "#e0edff"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "m136 480h56v-16l-24-16-32 8z",
    fill: "#d1e4ff"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "m136 152v24a15.99555 15.99555 0 0 1 -16-16v-8z",
    fill: "#ffbfa1"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "m128 168a16 16 0 0 1 -16-16v-8l8-8h24v16a16 16 0 0 1 -16 16z",
    fill: "#ffceb6"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "m144 136 4.68629-4.68629a11.31372 11.31372 0 0 0 3.31371-8 11.31369 11.31369 0 0 0 -11.3137-11.31371h-12.6863a16 16 0 0 0 -16 16v16l8-8z",
    fill: "#c47220"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "#f78e00",
    height: 24,
    rx: 8,
    width: 16,
    x: 200,
    y: 120
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    fill: "#f78e00",
    height: 40,
    rx: 8,
    width: 16,
    x: 288,
    y: 120
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "m264 72v28a12 12 0 1 1 -24 0v-28z",
    fill: "#ffceb6"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "m264 72v24a15.99555 15.99555 0 0 1 -16-16v-8z",
    fill: "#ffbfa1"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "m256 88a16 16 0 0 1 -16-16v-8l8-8h24v16a16 16 0 0 1 -16 16z",
    fill: "#ffceb6"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "m272 56 4.68629-4.68629a11.31372 11.31372 0 0 0 3.31371-8 11.31369 11.31369 0 0 0 -11.3137-11.31371h-12.6863a16 16 0 0 0 -16 16v16l8-8z",
    fill: "#c47220"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeam);
export default __webpack_public_path__ + "static/media/team.eec2d404409b2e933f3a482cfcc9912c.svg";
export { ForwardRef as ReactComponent };